<template>
  <div>
    <el-table
        :data="tableData"
        border
        stripe
        style="width: 100%">
      <el-table-column
          prop="ID"
          label="ID"
          width="80">
      </el-table-column>
      <el-table-column
          prop="Name"
          label="用户昵称">
      </el-table-column>
      <el-table-column
          prop="Phone"
          label="手机号码"
          >
      </el-table-column>
      <el-table-column
          prop="IsAdmin"
          label="是否是管理员"
          width="180">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.IsAdmin==1" type="success">是</el-tag>
          <el-tag v-if="scope.row.IsAdmin==0" type="danger">否</el-tag>
        </template>
      </el-table-column>


      <el-table-column

          label="设置为管理员"
          width="120">
        <template slot-scope="scope">
          <el-button @click="changeUsers(scope.row)" type="text" size="small">设置/取消</el-button>
        </template>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import http from '../utils/http-base'
export default {
  name: "admin-user",
  data(){
    return{
      tableData: [{
        name: 'iphone',
        num: '10',
        status: '上架',
        des:'iphone手机'
      }, {
        name: '小米',
        num: '10',
        status: '下架',
        des:'小米手机'
      },]

    }
  },
  methods:{
    changeInfor() {
      http.post("/login/", {
        name:this.loginForm.name,
        pwd: this.loginForm.pwd,
        phone: this.loginForm.phone,
        re: this.loginForm.re
      }).then(res=>{
        if (res.data.code ===0){
          this.$message({
            message: '恭喜你，修改成功',
            type: 'success'
          });
          this.getInfor()
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getInfor() {
      http.get("/login/", ).then(res=>{
        if (res.data.code ===0){
          this.loginForm=res.data.msg
        }else{
          this.$message.error("请先登录")
          window.location.href="index.html"
        }
      })
    },

    addGoods() {
      http.post("/goods/", {
        name:this.addGoodsForm.name,
        num: this.addGoodsForm.num,
        status: this.addGoodsForm.status,
        des: this.addGoodsForm.des
      }).then(res=>{
        if (res.data.code ===0){
          this.$message({
            message: '恭喜你，添加商品成功',
            type: 'success'
          });
          this.addGoodsVisible = false
          this.getGoods()

        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getUsers() {
      http.get("/api/login/all/", ).then(res=>{
        if (res.data.code ===0){
          this.tableData=res.data.data
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    changeUsers(v) {
      http.post("/api/login/admin",
      {
          "ID": v.ID,
          "Name": v.Name,
          "IsAdmin": v.IsAdmin
      }).then(res=>{
        if (res.data.code ===0){
          this.$message({
            message: '操作成功!',
            type: 'success'
          });
          this.getUsers()
        }else {
          this.$message.error(res.data.msg)
        }
      })
    },
    },
    mounted() {
      // 页面打开时需要执行的操作
      this.getUsers();
    },
  }
</script>

<style scoped>

</style>